module.exports = __webpack_public_path__ + "static/media/Ex2-S6-ToolAns.966e1b08.png";